import { cn } from "@/utils/cn";

interface PencomCardProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    title?: string;
    extra?: React.ReactNode;
    description?: React.ReactNode;
    className?: string;
    extraClassName?: string;
}

export const PencomCard = ({ children, title, extra, description, className, extraClassName, ...rest }: PencomCardProps) => {
    return (
        <div {...rest} className={cn("flex flex-col bg-white rounded-2xl p-6 border border-stroke", className)}>
            {title && (
                <div className="flex flex-col gap-x-4 gap-y-2">
                    <div className={cn("flex flex-row gap-x-4 items-center", extraClassName)}>
                        <p className="font-clash-display text-medium-dark-grey text-xl font-semibold">{title}</p>
                        {extra}
                    </div>
                    {description}
                </div>
            )}
            {children}
        </div>
    );
};